import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';

const VendorRoute = () => {
  const { activeRole, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (activeRole !== 'vendor') {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default VendorRoute;